import { uaCheck } from "./modules/utils";

uaCheck();

function initImgToggle() {
  // 全ての画像セットを取得
  const uniformSets = document.querySelectorAll('.uniform-img');

  // 各セットに対してイベントリスナーを設定
  uniformSets.forEach(set => {
    const frontImg = set.querySelector('.front.img');
    const backImg = set.querySelector('.back.img');
    const toggleIcon = set.querySelector('.toggle-icon');

    set.querySelector('.button img').addEventListener('click', () => {
      if (frontImg.classList.contains('active')) {
        frontImg.classList.remove('active');
        backImg.classList.add('active');
        toggleIcon.src = toggleIcon.src.includes('backicon')
          ? toggleIcon.src.replace('backicon', 'fronticon')
          : toggleIcon.src; // 画像名の変更
      } else {
        frontImg.classList.add('active');
        backImg.classList.remove('active');
        toggleIcon.src = toggleIcon.src.includes('fronticon')
          ? toggleIcon.src.replace('fronticon', 'backicon')
          : toggleIcon.src; // 画像名の変更
      }
    });
  });
}

function scrollEffect() {
  const targets = document.querySelectorAll(".effect");
  const options = {
    root: null,
    rootMargin: "-40px",
    threshold: 0,
  };

  const observer = new IntersectionObserver((entries) => {
    entries.forEach((entry, index) => {
      if (entry.isIntersecting) {
        // 各要素に対して遅延を設定
        entry.target.style.transitionDelay = `${index * 0.2}s`; // 0.2秒ごとにディレイ
        entry.target.classList.add("active");
      }
    });
  }, options);

  targets.forEach((target) => {
    observer.observe(target);
  });
}

window.addEventListener('load', () => {
  initImgToggle();
  scrollEffect();
});
